// ToDo: delete enum: temporary - types getting from server
export enum KnmTypeIdsByCodeEnum {
  KZ = 2,
  PP = 0,
  VP = 1,
}
